module.exports = __webpack_public_path__ + "img/logo.8dacf237.svg";